import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Home } from './pages/Home';
import { Eat } from './pages/Eat';
import { Drink } from './pages/Drink';
import { Nightlife } from './pages/Nightlife';
import { GalleryPage } from './pages/GalleryPage';
import { Booking } from './pages/Booking';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-obsidian" data-id="element-1">
        <Navbar data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/eat" element={<Eat data-id="element-7" />} data-id="element-6" />
          <Route path="/drink" element={<Drink data-id="element-9" />} data-id="element-8" />
          <Route path="/nightlife" element={<Nightlife data-id="element-11" />} data-id="element-10" />
          <Route path="/gallery" element={<GalleryPage data-id="element-13" />} data-id="element-12" />
          <Route path="/booking" element={<Booking data-id="element-15" />} data-id="element-14" />
        </Routes>
      </div>
    </BrowserRouter>;
}